import { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Button,
  CardMedia,
  Card,
  Typography,
  Avatar,
  Menu,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHeader } from "./UseHeader";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { SketchPicker } from "react-color";
import { useSnackbar } from "notistack";
import { readFromLS } from "../../../util/LocalStrogeService";

export default function AddTopBanner() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetHeader, SetHeaderTopBanner } = UseHeader();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [homePageId, setHomePageid] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : ""
  );
  const [state, setState] = useState({
    id: 0,
    active: false,
    url: "/",
    color: undefined,
    width1: undefined,
    width2: undefined,
    height1: undefined,
    height2: undefined,
    headerID: homePageId ? homePageId.id : 1,
  });

  const [imgState, setImgState] = useState({
    imageFile1: undefined,
    imageUrl1: undefined,
    imageFile2: undefined,
    imageUrl2: undefined,
  });

  const handleChangeImage1 = (file) => {
    const img = new Image();
    img.src = URL.createObjectURL(file[0]);
    img.onload = () => {
      setState({ ...state, width1: img.width, height1: img.height });
    };

    setImgState({
      ...imgState,
      imageFile1: file[0],
      imageUrl1: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage2 = (file) => {
    const img = new Image();
    img.src = URL.createObjectURL(file[0]);
    img.onload = () => {
      setState({ ...state, width2: img.width, height2: img.height });
    };
    setImgState({
      ...imgState,
      imageFile2: file[0],
      imageUrl2: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/homepagemanage" },
          {
            name: "مدیریت هدر",
          },
          {
            name: "افزودن هدر",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box gridColumn="span 7">
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage1(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "100%", height: "100%" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl1
                        ? imgState.imageUrl1
                        : "/static/img/NoAdv.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
        </Box>
        <Box gridColumn="span 2">
          <TextField
            fullWidth
            value={state.width1 ? state.width1 : ""}
            label="عرض"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, width1: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 2">
          <TextField
            fullWidth
            value={state.height1 ? state.height1 : ""}
            label="طول"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, height1: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 1"></Box>

        <Box gridColumn="span 6">
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage2(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "100%", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl2
                        ? imgState.imageUrl2
                        : "/static/img/NoAdv.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
        </Box>
        <Box gridColumn="span 2">
          <TextField
            fullWidth
            value={state.width2 ? state.width2 : ""}
            label="عرض"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, width2: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 2">
          <TextField
            fullWidth
            value={state.height2 ? state.height2 : ""}
            label="طول"
            sx={{
              input: {
                direction: "rtl",
              },
            }}
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, height2: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 1"></Box>
        <Box gridColumn="span 10">
          <TextField
            // fullWidth
            sx={{
              width: "50%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.url ? state.url : ""}
            // error={errorState.url}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, url: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 3">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body1"> رنگ هدر :</Typography>
            <Avatar
              sx={{
                bgcolor: state.color,
                boxShadow: 3,
                width: 35,
                height: 35,
                mx: 1,
              }}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => {
                setAnchorEl(event.currentTarget);
              }}
            >
              {" "}
            </Avatar>
            <Typography variant="body1">
              {state.color ? state.color : ""}
            </Typography>{" "}
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            sx={{
              "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
                py: 0,
              },
            }}
          >
            <SketchPicker
              sx={{ position: "relative", top: "-130px" }}
              color={state.color ? state.color : ""}
              onChangeComplete={(color) => {
                setState({ ...state, color: color.hex });
              }}
            />
          </Menu>
        </Box>
        <Box gridColumn="span 9"></Box>
        <Box gridColumn="span 3">
          <FormControlLabel
            control={
              <Checkbox
                checked={state.active}
                onChange={(evt) => {
                  setState({
                    ...state,
                    active: evt.target.checked,
                  });
                }}
              />
            }
            label={<Typography variant="subtitle1">فعال</Typography>}
          />
        </Box>
        <Box gridColumn="span 9"></Box>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box
          gridColumn="span 12"
          sx={{ my: 2, display: "flex", justifyContent: "center" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              if (
                !state.color ||
                !state.url ||
                !imgState.imageUrl1 ||
                !imgState.imageUrl2 ||
                !state.height1 ||
                !state.height2 ||
                !state.width1 ||
                !state.width2
              ) {
                enqueueSnackbar("لطفا اطلاعات بنر هدر را کامل وارد کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
              //   if (validateItem(state, setErrorState) == 200) {
              setProgress(true);
              SetHeaderTopBanner(
                state,
                imgState.imageFile1,
                imgState.imageFile2,
                (calback) => {
                  navigate("/headerManage", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                }
              );
              //   }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/headerManage", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
